/* 
<svg height="200" width="200" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
    <polygon points="200 200, -0.000 200, 98.39 98.39, 200 -0.000, 200 200" fill="black" />
    <polygon points="177.64 9.27, 9.27 9.27, 9.27 177.64, -0.000 200, 200 -0.000, 177.64 9.27" />
</svg>
*/

// Create a class for the element
class Corner extends HTMLElement {

    constructor() {
        super();
    }

    creactCornerSvg() {
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.classList.add("corner");

        if(this.hasAttribute("animate")){
            svg.classList.add("corner--animate");
        }

        if(this.hasAttribute("bottom-right")){
            svg.classList.add("corner--bottom-right");
        }

        if(this.hasAttribute("bottom-left")){
            svg.classList.add("corner--bottom-left");
        }

        svg.setAttribute("viewBox", "0 0 200 200");
        svg.setAttribute("aria-label", "corner");
        svg.setAttribute("role", "img");

        const polygonBackground = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "polygon"
        );
        polygonBackground.setAttribute("points", "200 200, -0.000 200, 98.39 98.39, 200 -0.000, 200 200");
        polygonBackground.setAttribute(
            "fill",
            this.getAttribute("negative-color") ??
            window
                .getComputedStyle(this)
                .getPropertyValue("--theme-signpost-background")
        );
        svg.appendChild(polygonBackground);

        const polygon = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "polygon"
        );
            polygon.setAttribute("points", "177.64 9.27, 9.27 9.27, 9.27 177.64, -0.000 200, 200 -0.000, 177.64 9.27");
            polygon.setAttribute(
            "fill",
            this.getAttribute("positive-color") ??
                window
                .getComputedStyle(this)
                .getPropertyValue("--theme-signpost-corner-background")
        );
        svg.appendChild(polygon);
        return svg;
    }

    connectedCallback() {
        const svg = this.creactCornerSvg();
        this.appendChild(svg);
    }
}

customElements.define("corner-element", Corner);
